<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen p-3">
        <div class="col-span-12 sm:col-span-6 lg:col-span-4">
            <div class="d-sm-flex gap-4">
                <b-form-select
                    class="h-11 border-gray-300 focus:ring-0 mt-3 mt-sm-0"
                    v-model="selectedYear"
                    :options="optionsYear"
                >
                </b-form-select>
                <b-form-select
                    class="h-11 border-gray-300 focus:ring-0"
                    v-model="selectedMonthFrom"
                    :options="optionsMonth">
                </b-form-select>
                <b-form-select
                    class="h-11 border-gray-300 focus:ring-0 mt-3 mt-sm-0"
                    v-model="selectedMonthTo"
                    :options="optionsMonth"
                >
                </b-form-select>
                <b-button
                    variant="primary"
                    class="mx-0 mt-3 mt-sm-0 mx-md-2 my-sm-0 focus:outline-none"
                    type="button"
                    @click="fetchReports()"
                >
                    <img src="/images/search1.png" alt="" class="h-6 cursor-pointer">
                </b-button>
            </div>
        </div>
        <table class="w-full table-bordered mt-3">
            <thead class="bg-lightGray h-11">
            <tr class="text-center">
                <th>{{ $t('category') }}</th>
                <th v-for="(monthName, index) of getIAOReport.listMonthNames" :key="index">
                    {{ $t('company.month.' + monthName) }}
                </th>

                <th class="d-none d-lg-table-cell">{{ $t('printView.totalSum') }}</th>
            </tr>
            </thead>
            <tbody v-for="(report, index) of getIAOReport.reports" :key="index">
                <tr class="h-11 text-center">
                    <td class=" bg-lightGray"> {{ getName(report.category.name) }}</td>
                    <td
                        v-for="(month, monthIndex) of report.byMonths"
                        :key="monthIndex"
                    >
                        <div
                            v-if="month.totalSum"
                            :style="{color: backgroundColor(report.category.isIncome)}"
                        >
                            <span class="">
                                {{ getSum(showCurrencyById(getUserCompany.baseCurrency.id, month.totalSum), report.category.isIncome)}}
                            </span>
                            <span
                                class="bg-lightGray pr-1 float-right"
                                style="color: #46BDA1; cursor: pointer;"
                                @click="incomeAndOutcomes = month.incomeAndOutcomes; showIncomesAll(index); indexMonth = monthIndex"
                            >
                                <img
                                    v-if="indexReport === index && monthIndex === indexMonth"
                                    src="/images/down-arrow-blue.png"
                                    class="h-4 mb-1"
                                    alt="down_arrow"
                                >
                                <img
                                    v-else src="/images/right-arrow%20-blue.png"
                                    class="h-2.5 mb-1"
                                    alt="down_arrow"
                                >
                            </span>
                        </div>
                        <div v-else>
                            -
                        </div>
                    </td>
                    <td
                        class="d-none d-lg-table-cell bg-lightGray font-bold"
                        :style="{color: backgroundColor(report.category.isIncome)}"
                    >
                        {{ getSum(showCurrencyById(getUserCompany.baseCurrency.id, report.byCategoryTotalSum), report.category.isIncome)}}
                    </td>
                </tr>
                <tr v-if="indexReport === index">
                    <td></td>
                    <td colspan="4">
                        <table class="w-full p-3">
                            <thead class="h-10">
                            <tr class="text-center">
                                <th class="d-none d-md-table-cell">{{ $t('date') }}</th>
                                <th class="d-none d-xl-table-cell">{{ $t('productsInWarehouse.reason') }}</th>
                                <th>{{ $t('sale.sum') }}</th>
                                <th>{{ $t('finance.count') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(incomeAndOutcome, index ) of incomeAndOutcomes" :key="index">
                                <td class="d-none d-md-table-cell">
                                    {{ dateTimeFormat(incomeAndOutcome.createdAt, true) }}
                                </td>
                                <td v-if="incomeAndOutcome.person !== null" class="d-none d-xl-table-cell">
                                    {{incomeAndOutcome.person.givenName + ' ' + incomeAndOutcome.person.familyName}}
                                </td>
                                <td v-else class="d-none d-xl-table-cell">
                                    {{incomeAndOutcome.reason}}
                                </td>
                                <td :style="{color: backgroundColor(incomeAndOutcome.isIncome)}">
                                    {{ getSum(showCurrencyById(incomeAndOutcome.sumCurrency.id, incomeAndOutcome.sum), incomeAndOutcome.isIncome) }}
                                </td>
                                <td :style="{color: backgroundColor(incomeAndOutcome.isIncome)}">
                                <span v-if="incomeAndOutcome.companyCount.isMain">
                                    {{$t('main')}}
                                </span>
                                    <span v-else>
                                    {{incomeAndOutcome.companyCount.name}}
                                </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr v-if="getIAOReport.reports.length - 1 === index" class="h-11 text-center">
                    <th class="bg-lightGray font-bold">{{$t('incomeAndOutcome.allIncome')}}</th>
                    <td
                        v-for="(income, index) of getIAOReport.totalSumByIncomes"
                        :key="index"
                    >
                        <span v-if="income !== 0" :style="{color: backgroundColor(true)}">
                            {{ getSum(showCurrencyById(getUserCompany.baseCurrency.id, income), true)}}
                        </span>
                        <span v-else>
                            -
                        </span>
                    </td>
                </tr>
                <tr v-if="getIAOReport.reports.length - 1 === index" class="h-11 text-center">
                    <th class="bg-lightGray font-bold">{{$t('incomeAndOutcome.allOutlay')}}</th>
                    <td v-for="(outcome, index) of getIAOReport.totalSumByOutcomes" :key="index">
                        <span v-if="outcome !== 0" :style="{color: backgroundColor(false)}">
                            {{ getSum(showCurrencyById(getUserCompany.baseCurrency.id, outcome), false)}}
                        </span>
                        <span v-else>
                            -
                        </span>
                    </td>
                </tr>
                <tr v-if="getIAOReport.reports.length - 1 === index" class="h-11 text-center">
                    <th class="bg-lightGray font-bold">{{$t('finance.financialSituation')}}</th>
                    <td
                        class="bg-lightGray font-bold"
                        v-for="(income, index) of totalSumByIncomes"
                        :key="index"
                    >
                        <span v-if="income" :style="{color: backgroundColor(income - totalSumByOutcomes[index] > 0 )}">
                            <span v-if="income - totalSumByOutcomes[index] > 0">+</span>
                            {{showCurrencyById(getUserCompany.baseCurrency.id, income - totalSumByOutcomes[index])}}
                        </span>
                        <span v-else>
                            -
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import currencyFormatMixin from "../../mixin/currencyFormatMixin";
import dateFormatting from "../../mixin/dateFormattingMixin";
import accessMixin from "@/mixin/accessMixin";
import Row from "@/components/html/Row";
import currencyRateMixin from "@/mixin/currencyRateMixin";
export default {
    name: "Report",
    components: {
        Row,
    },
    mixins: [currencyFormatMixin, currencyRateMixin, dateFormatting, accessMixin],
    data() {
        return {
            indexReport: null,
            indexMonth: null,
            isShowIncomeAndOutcomeList: false,
            incomeAndOutcomes: [],
            optionsYear: [],
            totalSumByIncomes: [],
            totalSumByOutcomes: [],
            selectedYear: null,
            selectedMonthFrom: null,
            selectedMonthTo: null,
            currentMonth: null,
            currentDate: null,
            currentYear: null,
            optionsMonth: [],
            allOptionsMonth: [
                {value: {start: '01-01', end: '01-31', indexNumber: 0}, text: this.$t('statistics.month.Jan'), disabled: false},
                {value: {start: '02-01', end: '02-28', indexNumber: 1}, text: this.$t('statistics.month.Feb'), disabled: false},
                {value: {start: '03-01', end: '03-31', indexNumber: 2}, text: this.$t('statistics.month.Mar'), disabled: false},
                {value: {start: '04-01', end: '04-30', indexNumber: 3}, text: this.$t('statistics.month.Apr'), disabled: false},
                {value: {start: '05-01', end: '05-31', indexNumber: 4}, text: this.$t('statistics.month.May'), disabled: false},
                {value: {start: '06-01', end: '06-30', indexNumber: 5}, text: this.$t('statistics.month.Jun'), disabled: false},
                {value: {start: '07-01', end: '07-31', indexNumber: 6}, text: this.$t('statistics.month.Jul'), disabled: false},
                {value: {start: '08-01', end: '08-31', indexNumber: 7}, text: this.$t('statistics.month.Aug'), disabled: false},
                {value: {start: '09-01', end: '09-30', indexNumber: 8}, text: this.$t('statistics.month.Sep'), disabled: false},
                {value: {start: '10-01', end: '10-31', indexNumber: 9}, text: this.$t('statistics.month.Oct'), disabled: false},
                {value: {start: '11-01', end: '11-30', indexNumber: 10}, text: this.$t('statistics.month.Nov'), disabled: false},
                {value: {start: '12-01', end: '12-31', indexNumber: 11}, text: this.$t('statistics.month.Dec'), disabled: false},
            ],
        }
    },
    computed: {
        ...mapGetters([
            'getIAOReport',
            'getUserCompanyCreatedAt',
            'getUserCompany'
        ]),
    },
    methods: {
        ...mapActions([
            'fetchUser',
            'fetchIncomeAndOutcomeReport'
        ]),
        createYear() {
            let created = parseInt(this.getUserCompanyCreatedAt)

            while (created <= new Date().getFullYear()) {
                this.optionsYear.push({value: created, text: created})
                created++
            }

            this.setYear()
            this.yearlyStat()
        },
        showIncomesAll(index) {
            if (this.indexReport === index) {
                this.indexReport = null
                this.incomeAndOutcomes = []
            } else {
                this.indexReport = index
            }
        },
        setYear() {
            this.selectedYear = this.optionsYear[this.optionsYear.length - 1].value
        },
        yearlyStat() {
            // eslint-disable-next-line no-undef
            this.optionsMonth = structuredClone(this.allOptionsMonth)
            let fromMonthIndex = 0
            let toMonthIndex = 11
            this.selectedMonthFrom = this.optionsMonth[0].value
            this.selectedMonthTo = this.optionsMonth[11].value

            if(this.selectedYear === parseInt(this.getUserCompanyCreatedAt)) {
                this.selectedMonthFrom = this.optionsMonth[new Date(this.getUserCompanyCreatedAt).getMonth()].value
                fromMonthIndex = new Date(this.getUserCompanyCreatedAt).getMonth()
            }

            if(this.selectedYear === this.currentYear) {
                this.selectedMonthTo = this.optionsMonth[this.currentMonth].value
                toMonthIndex = this.currentMonth
            }

            for(let index in this.optionsMonth) {
                if(index < fromMonthIndex || index > toMonthIndex) {
                    this.optionsMonth[index].disabled = true
                }
            }
        },
        getTodayDate() {
            let yearNow = new Date().getFullYear()
            let monthNow = new Date().getMonth() + 1
            let dateNow = new Date().getDate()

            return yearNow + '-' + this.addZero(monthNow) + '-' + this.addZero(dateNow)
        },
        addZero(val) {
            return val < 10 ? '0' + val : val;
        },
        prepareDate() {
            let date = {}

            if(this.selectedMonthFrom.indexNumber > this.selectedMonthTo.indexNumber) {
                date = {
                    dateFrom: this.selectedYear + '-' + this.selectedMonthTo.start + 'T00:00:00',
                    dateTo: this.selectedYear + '-' + this.selectedMonthFrom.end + 'T23:59:59',
                }
            } else {
                date = {
                    dateFrom: this.selectedYear + '-' + this.selectedMonthFrom.start + 'T00:00:00',
                    dateTo: this.selectedYear + '-' + this.selectedMonthTo.end + 'T23:59:59',
                }
            }

            return date
        },
        fetchReports() {
            this.$root.showOverlay = true
            this.fetchIncomeAndOutcomeReport(this.prepareDate())
                .then(() => {
                    this.totalSumByIncomes = Object.keys(this.getIAOReport.totalSumByIncomes).map((key) => this.getIAOReport.totalSumByIncomes[key])
                    this.totalSumByOutcomes = Object.keys(this.getIAOReport.totalSumByOutcomes).map((key) => this.getIAOReport.totalSumByOutcomes[key])
                })
                .finally(() => {
                    this.$root.showOverlay = false
                })
        },
        getName(categoryName) {
            switch (categoryName) {
                case "sale":
                case "purchase":
                case "rent":
                case "salary":
                case "communal":
                case "debt":
                case "credit":
                case "paymentSystem":
                    return this.$t("finance.income." + categoryName)

                default:
                    return categoryName
            }
        },

        backgroundColor(isIncome) {
            if(isIncome === null) {
                return ' '
            }

            return isIncome ? '#1DD919' : '#FF0000'
        },
        getSum(sum, isIncome) {
            if(isIncome === null) {
                return sum
            }

            return isIncome ? '+' + sum : '-' + sum
        },
    },
    watch: {
        selectedYear() {
            this.yearlyStat()
        }
    },

    mounted() {
        this.$root.showOverlay = true
        this.fetchUser()
            .then(() => {
                this.currentYear = new Date().getFullYear()
                this.currentMonth = new Date().getUTCMonth()
                this.currentDate = this.getTodayDate()
                this.createYear()
                this.fetchReports()
            })
            .catch((error) => {
                console.log(error)
                this.$root.showOverlay = false
            })

        this.$root.showOverlay = false

    },
}
</script>
<style scoped>


table tbody tr {
    border-bottom: 1px solid #eaeaea;
}

.button-stat {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background-color: #E5E5E5;
    color: #707070;
    height: 35px;
    width: 100px;
}

.button-stat:checked:active:focus {
    background-color: #6539B2 !important;
}

.button-stat:active {
    background-color: #6539B2 !important;
}


.danger {
    background-color: #bd2130;
    border-color: #bd2130;
    color: white;
}

.danger:hover {
    background-color: red;
    border-color: red;
}

.btn-secondary {
    background-color: #ffffff !important;
    border: none;
    padding: 0;
}

.select-all {
    font-size: 16px;
    margin-top: 5px;
}

.form-control {
    margin-bottom: 5px !important;
}

.mb-3 {
    margin-bottom: -16px !important;
}

.col-1, .col-11 {
    padding: 0 !important;
}

.clear {
    clear: both;
}

@media only screen and (max-width: 845px) {
    ::placeholder {
        font-size: 15px;
    }
}

@media only screen and (max-width: 370px) {
    .date {
        font-size: 14px;
    }
}

.indicator-title {
    font-size: 16px;
    font-weight: 700;
    color: #000000;
}

.indicator-total {
    font-size: 18px;
    font-weight: 700;
    color: #8300C5;
}

.indicator {
    border-right: #444444 solid 1px;
    background-color: #F0EEF9;
    padding: 10px 0 10px 20px;
    margin: 1px 0;
}

.padding {
    padding-left: 0.75rem;
    padding-bottom: 0.75rem;
}

button {
    width: 100px;
}
</style>
